export const PLANS = [
  {
    id: "ar1",
    name: "1 år",
    months: 12,
    total: 828,
    perMonth: 69,
    tagline: "Prøv et helt år",
    popular: false,
  },
  {
    id: "ar3",
    name: "3 år",
    months: 36,
    total: 2124,
    perMonth: 59,
    tagline: "Mest valgt",
    popular: true,
  },
  {
    id: "ar5",
    name: "5 år",
    months: 60,
    total: 2940,
    perMonth: 49,
    tagline: "Best verdi",
    popular: false,
  },
];

export const FEATURES = [
  "GPS-tracker inkludert",
  "Sanntidssporing i app",
  "Geofence – digitale sikkerhetssoner",
  "Tyverialarm med sabotasjevarsel",
  "App for iOS og Android",
  "Norsk support",
];

export const priceFor = (plan, trackers = 1) => plan.total * trackers;
